import { render, staticRenderFns } from "./bottomCenter1.vue?vue&type=template&id=2a1ecc44&scoped=true&"
import script from "./bottomCenter1.vue?vue&type=script&lang=js&"
export * from "./bottomCenter1.vue?vue&type=script&lang=js&"
import style0 from "./bottomCenter1.vue?vue&type=style&index=0&id=2a1ecc44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1ecc44",
  null
  
)

export default component.exports